// src/oura/docs/signedIn.ts
//
// The signed-in person's name, the one every staff write records ("signed",
// "sent by", "filed by", "recorded by"). Null when the profile carries no name
// and no username: each sentence says "you" in its own words then. It also
// hands the name to the sample stores, so a write on the dev server records
// the person who clicked, as the server will from the token.

import { useEffect } from "react";
import { useUserProfileContext } from "@context/user_profile";
import { setSampleActor } from "@service/aeo/sampleActor";

export function useSignedInName(): string | null {
    const [, user] = useUserProfileContext();
    const name = [user?.first_name, user?.last_name].filter(Boolean).join(" ").trim() || user?.username?.trim() || null;
    useEffect(() => {
        setSampleActor(name);
    }, [name]);
    return name;
}
